import React from 'react';
import {
  Application,
  ApplicationStatus,
} from '../../../../../../../entities/Application';
import { IconButton } from '../../../../../../../components/IconButton';
import { VerticalDivider } from '../../../../../../../components/VerticalDivider';
import { RejectApplication } from './RejectApplication';
import { AlertObject } from '../../../../../../../components/Alert';
import { MoveApplication } from './MoveApplication';
import { AddNote } from './AddNote';
import { BULK_REVIEW_NAVIGATION_TYPE } from '../../../..';

interface PropTypes {
  application: Application;
  preSelectedRejectReasonId: number;
  isActionsDisabled: boolean;
  onNext: (navType: BULK_REVIEW_NAVIGATION_TYPE) => void;
  onClose: () => void;
  onConflict: () => void;
  setAlert: (alert: AlertObject) => void;
  setPreSelectedRejectReasonId: (id: number) => void;
}

export function ApplicationActions(props: PropTypes) {
  const isRejected = props.application.status === ApplicationStatus.Rejected;
  const isTransitionDisabled = props.isActionsDisabled || isRejected;

  return (
    <div className='pb-2'>
      <AddNote {...props} />
      {props.application.canTransitionApplication && (
        <>
          <RejectApplication
            {...props}
            disabled={isTransitionDisabled}
            onConflict={props.onConflict}
          />
          <MoveApplication
            {...props}
            disabled={isTransitionDisabled}
            onConflict={props.onConflict}
          />
        </>
      )}
      <VerticalDivider />
      <IconButton
        iconName='bi-skip-end'
        buttonText='Skip'
        buttonClass='ms-3h'
        color={isTransitionDisabled ? 'primary' : 'secondary'}
        position='end'
        onClick={() => props.onNext('skipped')}
      />
    </div>
  );
}
